import persistHelper from "~/utils/persist";
import { SET_THEME } from "~/store/theme/actions";

export const INITIAL_STATE = {
	theme: "dark",
};

export const PERSISTED_STATE = persistHelper.initState("theme", INITIAL_STATE);

export const REDUCER = (state = PERSISTED_STATE, action) => {
	switch (action.type) {
		case SET_THEME:
			return persistHelper.setPersist("theme", {
				theme: action.payload.theme,
			});
		default:
			return state;
	}
};
